<template>
	<div class="home">
		<div class="content filter-content">
			<h3>运营概览</h3>
			<div class="filter-group">
				<el-radio-group v-model="timeRange" @change="handleTimeRangeChange">
					<el-radio-button label="oneMonth">近一月</el-radio-button>
					<el-radio-button label="threeMonths">近三个月</el-radio-button>
					<el-radio-button label="sixMonths">近半年</el-radio-button>
					<el-radio-button label="oneYear">近一年</el-radio-button>
					<el-radio-button label="all">全部</el-radio-button>
					<el-radio-button label="custom">自定义</el-radio-button>
				</el-radio-group>

				<div class="date-picker-group" v-if="timeRange === 'custom'">
					<el-date-picker value-format="yyyy-MM-dd" @change="changeDaterange" v-model="daterange"
						type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						clearable />
					<el-button type="primary" plain icon="el-icon-search" @click="getData">查询</el-button>
				</div>
				<el-button v-else type="primary" plain icon="el-icon-search" @click="getData">查询</el-button>
			</div>
		</div>

		<div class="num-box">
			<div class="num-item">
				<div class="num-item-icon money">
					<i class="el-icon-money"></i>
				</div>
				<div class="num-item-title">
					<div class="num-item-name">保费金额</div>
					<div class="num-item-value">¥{{ formatAmount(data.num1 || 0) }}</div>
				</div>
			</div>

			<div class="num-item">
				<div class="num-item-icon user">
					<i class="el-icon-user"></i>
				</div>
				<div class="num-item-title">
					<div class="num-item-name">新增用户</div>
					<div class="num-item-value">{{ data.num2 || 0 }}</div>
				</div>
			</div>

			<div class="num-item">
				<div class="num-item-icon order">
					<i class="el-icon-document"></i>
				</div>
				<div class="num-item-title">
					<div class="num-item-name">保单数量</div>
					<div class="num-item-value">{{ data.num3 || 0 }}</div>
				</div>
			</div>

			<div class="num-item">
				<div class="num-item-icon refund">
					<i class="el-icon-warning"></i>
				</div>
				<div class="num-item-title">
					<div class="num-item-name">理赔申请</div>
					<div class="num-item-value">{{ data.num4 || 0 }}</div>
				</div>
			</div>
		</div>

		<div class="separate-content">
			<div class="line-chart">
				<div class="title">用户增长趋势</div>
				<div class="echart" id="userChart"></div>
			</div>
			<div class="pie-chart">
				<div class="title">用户投保分析</div>
				<div class="echart" id="userOrderChart"></div>
			</div>
		</div>

		<div class="content">
			<div class="element">
				<div class="title">保单统计分析</div>
				<div class="echart" id="orderChart"></div>
			</div>
		</div>

		<div class="separate-content bottom-charts">
			<div class="element">
				<div class="title">热门保险产品</div>
				<div class="echart" id="productChart"></div>
			</div>
			<div class="element">
				<div class="title">理赔状态分布</div>
				<div class="echart" id="claimStatusChart"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';

	export default {
		data() {
			return {
				timeRange: 'oneMonth', // 默认近一月
				form: {
					startDate: '',
					endDate: '',
					rangeType: 'oneMonth'
				},
				daterange: [],
				data: {
					num1: 0,
					num2: 0,
					num3: 0,
					num4: 0,
					userChart: {
						title: [],
						value: []
					},
					userOrderChart: [],
					orderChart: {
						title: [],
						sales: [],
						orders: []
					},
					productChart: {
						products: [],
						sales: []
					},
					claimStatusChart: []
				},
				charts: {}
			}
		},
		created() {
			this.initTimeRange();
			this.getData();
		},
		mounted() {
			// 监听窗口大小变化，重新渲染图表
			window.addEventListener('resize', this.handleResize);
		},
		methods: {
			formatAmount(amount) {
				return Number(amount).toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			},

			// 初始化时间范围
			initTimeRange() {
				this.calculateTimeRange('oneMonth');
			},

			// 处理时间范围切换
			handleTimeRangeChange(rangeType) {
				if (rangeType !== 'custom') {
					this.calculateTimeRange(rangeType);
					this.getData();
				}
			},

			// 计算时间范围
			calculateTimeRange(rangeType) {
				const now = new Date();
				let startDate = new Date();

				switch (rangeType) {
					case 'oneMonth':
						startDate.setMonth(now.getMonth() - 1);
						break;
					case 'threeMonths':
						startDate.setMonth(now.getMonth() - 3);
						break;
					case 'sixMonths':
						startDate.setMonth(now.getMonth() - 6);
						break;
					case 'oneYear':
						startDate.setFullYear(now.getFullYear() - 1);
						break;
					case 'all':
						// 全部数据，开始日期设为一个很早的日期
						startDate = new Date('2020-01-01');
						break;
					case 'custom':
						// 自定义范围，不自动设置日期
						return;
				}

				const formatDate = (date) => {
					const pad = num => num.toString().padStart(2, '0');
					return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}`;
				};

				this.form.startDate = formatDate(startDate) + ' 00:00:00';
				this.form.endDate = formatDate(now) + ' 23:59:59';
				this.form.rangeType = rangeType;

				// 更新日期选择器显示（如果是自定义模式）
				if (rangeType !== 'custom') {
					this.daterange = [formatDate(startDate), formatDate(now)];
				}
			},

			changeDaterange(e) {
				if (!e) {
					this.timeRange = 'oneMonth';
					this.calculateTimeRange('oneMonth');
				} else {
					this.form.startDate = e[0] + ' 00:00:00';
					this.form.endDate = e[1] + ' 23:59:59';
					this.form.rangeType = 'custom';
				}
			},

			async getData() {
				try {
					this.$loading({
						text: '加载中...'
					});

					// 确保时间范围参数正确
					if (this.timeRange !== 'custom') {
						this.form.rangeType = this.timeRange;
					}

					const res = await this.$get('home-statistics', this.form);
					this.data = this.safeMerge(this.data, res.data);

					// 初始化所有图表
					this.$nextTick(() => {
						this.initUserChart();
						this.initUserOrderChart();
						this.initOrderChart();
						this.initProductChart();
						this.initClaimStatusChart();
					});

					this.$loading().close();
				} catch (err) {
					this.$loading().close();
					this.$message.error(err.message || '数据加载失败');
				}
			},

			// 安全合并数据，避免undefined错误
			safeMerge(target, source) {
				const result = {
					...target
				};
				for (const key in source) {
					if (source[key] !== undefined && source[key] !== null) {
						result[key] = source[key];
					}
				}
				return result;
			},

			initUserChart() {
				const chartDom = document.getElementById('userChart');
				if (!chartDom) return;

				if (this.charts.userChart) {
					this.charts.userChart.dispose();
				}

				const myChart = echarts.init(chartDom);
				this.charts.userChart = myChart;

				const userChartData = this.data.userChart || {};
				const titles = userChartData.title || [];
				const values = userChartData.value || [];

				const option = {
					tooltip: {
						trigger: 'axis',
						formatter: '{b}<br/>新增用户: {c}人'
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: titles,
						axisLabel: {
							rotate: 45
						}
					},
					yAxis: {
						type: 'value',
						name: '用户数'
					},
					series: [{
						name: '新增用户',
						type: 'line',
						smooth: true,
						data: values,
						itemStyle: {
							color: '#5470c6'
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: 'rgba(84, 112, 198, 0.5)'
								}, {
									offset: 1,
									color: 'rgba(84, 112, 198, 0.1)'
								}]
							}
						}
					}]
				};

				myChart.setOption(option);
			},

			initUserOrderChart() {
				const chartDom = document.getElementById('userOrderChart');
				if (!chartDom) return;

				if (this.charts.userOrderChart) {
					this.charts.userOrderChart.dispose();
				}

				const myChart = echarts.init(chartDom);
				this.charts.userOrderChart = myChart;

				const userOrderData = this.data.userOrderChart || [];

				const option = {
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c}人 ({d}%)'
					},
					legend: {
						orient: 'vertical',
						left: 'left',
						top: 'center'
					},
					series: [{
						name: '用户投保分析',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 18,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: userOrderData
					}]
				};

				myChart.setOption(option);
			},

			initOrderChart() {
				const chartDom = document.getElementById('orderChart');
				if (!chartDom) return;

				if (this.charts.orderChart) {
					this.charts.orderChart.dispose();
				}

				const myChart = echarts.init(chartDom);
				this.charts.orderChart = myChart;

				const orderChartData = this.data.orderChart || {};
				const titles = orderChartData.title || [];
				const sales = orderChartData.sales || [];
				const orders = orderChartData.orders || [];

				const option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						}
					},
					legend: {
						data: ['保费收入', '保单数量']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: titles,
						axisPointer: {
							type: 'shadow'
						},
						axisLabel: {
							rotate: 45
						}
					}],
					yAxis: [{
						type: 'value',
						name: '保费收入',
						axisLabel: {
							formatter: '¥{value}'
						}
					}, {
						type: 'value',
						name: '保单数量',
						axisLabel: {
							formatter: '{value} 单'
						}
					}],
					series: [{
						name: '保费收入',
						type: 'bar',
						barWidth: '60%',
						data: sales,
						itemStyle: {
							color: '#91cc75'
						}
					}, {
						name: '保单数量',
						type: 'line',
						yAxisIndex: 1,
						data: orders,
						itemStyle: {
							color: '#5470c6'
						}
					}]
				};

				myChart.setOption(option);
			},

			initProductChart() {
				const chartDom = document.getElementById('productChart');
				if (!chartDom) return;

				if (this.charts.productChart) {
					this.charts.productChart.dispose();
				}

				const myChart = echarts.init(chartDom);
				this.charts.productChart = myChart;

				const productChartData = this.data.productChart || {};
				const products = productChartData.products || ['户外活动险', '户外保社会活动险', '其他产品'];
				const sales = productChartData.sales || [120, 200, 150];

				const option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: '{b}<br/>销量: {c}单'
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: '10%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: products,
						axisLabel: {
							interval: 0,
							rotate: 0
						}
					},
					series: [{
						name: '销量',
						type: 'bar',
						data: sales,
						itemStyle: {
							color: function(params) {
								const colorList = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de'];
								return colorList[params.dataIndex] || '#5470c6';
							}
						}
					}]
				};

				myChart.setOption(option);
			},

			initClaimStatusChart() {
				const chartDom = document.getElementById('claimStatusChart');
				if (!chartDom) return;

				if (this.charts.claimStatusChart) {
					this.charts.claimStatusChart.dispose();
				}

				const myChart = echarts.init(chartDom);
				this.charts.claimStatusChart = myChart;

				const claimStatusData = this.data.claimStatusChart || [{
						value: 335,
						name: '审核中'
					},
					{
						value: 310,
						name: '已赔付'
					},
					{
						value: 234,
						name: '待审核'
					},
					{
						value: 135,
						name: '已拒绝'
					}
				];

				const option = {
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c}件 ({d}%)'
					},
					legend: {
						bottom: '5%',
						left: 'center',
						type: 'scroll'
					},
					series: [{
						name: '理赔状态',
						type: 'pie',
						radius: ['30%', '60%'],
						center: ['50%', '45%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 10,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 16,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: claimStatusData
					}]
				};

				myChart.setOption(option);
			},

			// 窗口大小变化时重新调整图表
			handleResize() {
				Object.values(this.charts).forEach(chart => {
					if (chart && typeof chart.resize === 'function') {
						chart.resize();
					}
				});
			}
		},

		beforeDestroy() {
			// 销毁所有图表实例
			Object.values(this.charts).forEach(chart => {
				if (chart && typeof chart.dispose === 'function') {
					chart.dispose();
				}
			});
			// 移除事件监听
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>

<style scoped>
	.home {
		padding: 20px;
		background-color: #f5f7fa;
		/* 移除固定高度限制，允许内容自然扩展 */
		min-height: auto;
		overflow-y: auto; /* 确保内容超出时显示滚动条 */
	}

	.filter-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		gap: 20px;
	}

	.filter-group {
		display: flex;
		align-items: center;
		gap: 15px;
		flex-wrap: wrap;
	}

	.date-picker-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.content {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		margin-bottom: 20px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.num-box {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;
		margin-bottom: 20px;
	}

	.num-item {
		background: #fff;
		border-radius: 8px;
		padding: 24px;
		display: flex;
		align-items: center;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
	}

	.num-item:hover {
		transform: translateY(-5px);
	}

	.num-item-icon {
		width: 60px;
		height: 60px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 16px;
		font-size: 28px;
		color: #fff;
	}

	.num-item-icon.money {
		background: linear-gradient(135deg, #67c23a, #85ce61);
	}

	.num-item-icon.user {
		background: linear-gradient(135deg, #409eff, #66b1ff);
	}

	.num-item-icon.order {
		background: linear-gradient(135deg, #e6a23c, #ebb563);
	}

	.num-item-icon.refund {
		background: linear-gradient(135deg, #f56c6c, #f78989);
	}

	.num-item-title {
		flex: 1;
	}

	.num-item-name {
		color: #909399;
		font-size: 14px;
		margin-bottom: 8px;
	}

	.num-item-value {
		color: #303133;
		font-size: 24px;
		font-weight: 600;
	}

	.separate-content {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 20px;
		margin-bottom: 20px;
	}

	.bottom-charts {
		margin-bottom: 0 !important;
	}

	.line-chart,
	.pie-chart,
	.element {
		background: #fff;
		border-radius: 8px;
		padding: 20px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		display: flex;
		flex-direction: column;
		min-height: 400px;
	}

	.title {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 16px;
		padding-bottom: 12px;
		border-bottom: 1px solid #ebeef5;
		flex-shrink: 0;
	}

	.echart {
		width: 100%;
		flex: 1;
		min-height: 300px;
	}

	/* 响应式设计 */
	@media (max-width: 1200px) {
		.num-box {
			grid-template-columns: repeat(2, 1fr);
		}

		.separate-content {
			grid-template-columns: 1fr;
		}

		.bottom-charts .element {
			min-height: 350px;
		}
	}

	@media (max-width: 992px) {
		.filter-group {
			flex-direction: column;
			align-items: flex-start;
		}

		.date-picker-group {
			width: 100%;
			justify-content: flex-start;
		}
	}

	@media (max-width: 768px) {
		.filter-content {
			flex-direction: column;
			align-items: flex-start;
		}

		.filter-group {
			width: 100%;
			justify-content: flex-start;
		}

		.num-box {
			grid-template-columns: 1fr;
		}

		.echart {
			min-height: 250px;
		}

		.home {
			padding: 10px;
		}

		.content,
		.line-chart,
		.pie-chart,
		.element {
			padding: 15px;
		}

		.num-item {
			padding: 20px;
		}

		.num-item-icon {
			width: 50px;
			height: 50px;
			font-size: 24px;
		}

		.num-item-value {
			font-size: 20px;
		}
	}
</style>